import type { APIError, JsonApiResponse } from '~/interfaces/api/main';
import type { AuthUserData, AuthUserMeta } from '~/interfaces/users/main';

export const useUsersStore = defineStore('UsersStore', () => {
  const authUserData = ref<AuthUserData | null>(null);
  const authUserMeta = ref<AuthUserMeta | null>(null);
  const loading = ref<boolean>(false);
  const error = ref<APIError[] | null>(null);

  async function fetchMe (): Promise<void> {
    loading.value = true;
    try {
      const response = await useAuthFetchNext('me');
      if (isAPIErrorResponse(response)) {
        error.value = response.errors;
        return;
      }
      const payload = response as JsonApiResponse<AuthUserData>;
      authUserData.value = payload.data;
      authUserMeta.value = payload.meta as AuthUserMeta;
    } catch (caught) {
      console.error('[UsersStore] fetchMe', caught);
    } finally {
      loading.value = false;
    }
  }

  // `Boolean(...)` et pas le retour brut : les deux `?.` rendent `undefined` tant que /me n'a
  // pas répondu, et ces flags pilotent la visibilité de la navigation — un appelant qui
  // comparerait à `false` inverserait le gate.
  function userHasPermission (permissionName: string, scope = null): boolean {
    return Boolean(scope
      ? scope.permissions?.includes(permissionName)
      : authUserMeta.value?.permissions?.includes(permissionName));
  }

  return {
    authUserData,
    authUserMeta,
    loading,
    error,
    fetchMe,
    userHasPermission,
  };
});
